import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from './features-modules/auth/auth.service';
import { SharedService } from './shared/services/shared.service';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  toastMessage$ = this.globalUtilityService.toastMessage$;
  showLoginPopup = false; // Add this property

  @Output() close = new EventEmitter<void>();
  isLoggedIn = false;
  loginPopupStatus!: boolean;
  isAuthRoute!: boolean;
  subscription = new Subscription();
  constructor(
    public globalUtilityService: GlobalUtilityService,
    private _authService: AuthService,
    private _sharedService: SharedService,
    private _router: Router,
    private _globalUtilityService: GlobalUtilityService
  ) {
    this.subscription.add(
      this._authService.getLoginStatus().subscribe({
        next: (data) => {
          if (data.data.status) {
            this.globalUtilityService.setLoginStatus(true);
            this.isLoggedIn = true;
          } else {
            this.globalUtilityService.setLoginStatus(false);
            this.globalUtilityService.removeDataFromLocalStorage('token');
            this.globalUtilityService.removeDataFromLocalStorage('user');
          }
        },
        error: (error) => {
          this.globalUtilityService.setLoginStatus(false);
          this.globalUtilityService.removeDataFromLocalStorage('token');
          this.globalUtilityService.removeDataFromLocalStorage('user');
        },
      })
    );
  }

  ngOnInit() {
    this.subscription.add(
      this._router.events
        .pipe(
          filter(
            (event): event is NavigationEnd => event instanceof NavigationEnd
          )
        )
        .subscribe((event: NavigationEnd) => {
          this.isAuthRoute = event.url.includes('auth');
          let authKey =
            this.globalUtilityService.getDataFromLocalStorage(
              'loginPopupStatus'
            );
          // if (authKey) {
          //   this.loginPopupStatus = JSON.parse(authKey);
          // }
          // if (!this.isLoggedIn && !this.isAuthRoute && !this.loginPopupStatus) {
          //   setTimeout(() => {
          //     this.showLoginPopup = false;
          //   }, 10000);
          //   this.globalUtilityService.setDataOnLocalStorage(
          //     'loginPopupStatus',
          //     'true'
          //   );
          // }
        })
    );
  }

  closeModal() {
    this.close.emit();
  }
}
